import React from 'react';
import { M60UspModule } from '~/lib/data-contract';
import { Image, Text } from '~/shared/components';
import Flex from '~/shared/components/Flex';
import { useModuleTheme } from '../../hooks/useModuleTheme';
import { ModuleContainer } from '../ModuleContainer';
import styles from './M60USP.module.scss';

export type M60USPProps = M60UspModule;

export const M60USP = ({ items, priority, ...rest }: M60USPProps) => {
    const { textColor } = useModuleTheme(rest);

    return (
        <ModuleContainer hasGutter {...rest} className={styles.moduleContainer}>
            <ul className={styles.grid}>
                {items.map(({ headline, text, image, imageAltText }, index) => (
                    <li className={styles.item} key={index} style={{ color: textColor }}>
                        {image && (
                            <div className={styles.image}>
                                <Image
                                    {...image}
                                    alt={imageAltText}
                                    sizes="60px"
                                    priority={Boolean(priority)}
                                />
                            </div>
                        )}
                        <Flex column className={styles.uspText}>
                            {headline && (
                                <Text variant="body" as="p" className={styles.headline}>
                                    {headline}
                                </Text>
                            )}
                            {text && <Text variant="body" children={text} />}
                        </Flex>
                    </li>
                ))}
            </ul>
        </ModuleContainer>
    );
};
